import { render, staticRenderFns } from "./SAMLTestLogin.vue?vue&type=template&id=2c844a1e&scoped=true"
import script from "./SAMLTestLogin.vue?vue&type=script&lang=js"
export * from "./SAMLTestLogin.vue?vue&type=script&lang=js"
import style0 from "./SAMLTestLogin.vue?vue&type=style&index=0&id=2c844a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c844a1e",
  null
  
)

export default component.exports